import React from 'react';
import { CheckCircleOutline, ErrorOutline, HourglassEmpty } from '@mui/icons-material';
import { StatusChip } from '../ui';
import type { TranslateFn } from '../../i18n/useAppTranslation';
import type { RebateRequestStatus } from '../../services/rebateRequestsApi';

/** One status chip for a request, in the shared status vocabulary. `ns` is the i18n namespace holding `status.*`. */
export const rebateRequestChip = (status: RebateRequestStatus, t: TranslateFn, ns: string) => {
  const label = t(`${ns}.status.${status}`);
  if (status === 'approved') return <StatusChip label={label} tone="positive" size="small" icon={<CheckCircleOutline />} />;
  if (status === 'denied') return <StatusChip label={label} tone="problem" size="small" icon={<ErrorOutline />} />;
  if (status === 'pending') return <StatusChip label={label} tone="caution" size="small" icon={<HourglassEmpty />} />;
  return <StatusChip label={label} tone="neutral" size="small" />;
};
